import { render } from "./CoordinateComponent.vue?vue&type=template&id=057cba50&scoped=true"
import script from "./CoordinateComponent.vue?vue&type=script&lang=js"
export * from "./CoordinateComponent.vue?vue&type=script&lang=js"

import "./CoordinateComponent.vue?vue&type=style&index=0&id=057cba50&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057cba50"]])

export default __exports__